const config = {
    singlePointLogin: '',
    singlePointLogout: '',
    appId: '',
    staffSelector: {},
    defaultPage: '',
    uploadAppId: '',
    uploadAppKey: '',
    microReportUrl: '',
    microAmsUrl: '',
    srmItsmAppId: '',
    tmsItsmAppId: '',
    bmsItsmAppId: '',
    cciItsmAppId: '',
    systemId: '',
    productId: '',
    oneClassifyCode: '',
    twoClassifyCode: '',
    threeClassifyCode: '',
    monitorAppKey: '',
    monitorServiceName: '',
    monitorDsn: '',
    microCopUrl: '',
    microCciUrl: '',
    elUrl: '',
};

if (process.env.VUE_APP_ENV) {
    config.singlePointLogin = process.env.VUE_APP_LOGIN_URL;
    config.singlePointLogout = process.env.VUE_APP_LOGOUT_URL;
    config.staffSelector = {
        url: process.env.VUE_APP_STAFF_SELECTOR_URL,
        project: process.env.VUE_APP_STAFF_SELECTOR_PROJECT
    };
    config.appId = process.env.VUE_APP_APPID;
    config.defaultPage = process.env.VUE_APP_DEFAULT_PAGE;
    config.uploadAppId = process.env.VUE_APP_UPLOAD_APP_ID;
    config.uploadAppKey = process.env.VUE_APP_UPLOAD_APP_KEY;
    config.apiUrl = process.env.VUE_APP_API_URL;
    config.filePreviewUrl = process.env.VUE_APP_File_Preview;
    config.pdfPreviewUrl = process.env.VUE_APP_PDF_PREVIEW;
    config.bucket = 'srm';
    config.bigDataLogTokenUrl = process.env.VUE_APP_BIG_DATA_LOG_TOKEN_URL;
    config.bigDataLogUrl = process.env.VUE_APP_BIG_DATA_LOG_URL;
    config.bigDataLogAppSecrect = process.env.VUE_APP_BIG_DATA_LOG_APP_SECRECT;
    config.bigDataLogAppName = process.env.VUE_APP_BIG_DATA_LOG_APP_NAME;
    config.stampUrl = process.env.VUE_APP_STAMP_URL;
    config.mideaPay = process.env.VUE_APP_MIDEA_PAY_URL;
    config.printUrl = process.env.VUE_APP_PRINT_URL;
    config.printPDFUrl = process.env.VUE_APP_PRINT_PDF_URL;
    config.env = process.env.VUE_APP_ENV;
    config.cloudPrintUrl = process.env.VUE_APP_CLOUD_PRINT_URL;
    config.microReportUrl = process.env.VUE_APP_MICRO_REPORT_URL;
    config.microAmsUrl = process.env.VUE_APP_MICRO_AMS_URL;
    config.microCopUrl = process.env.VUE_APP_MICRO_COP_URL;
    config.microCciUrl = process.env.VUE_APP_MICRO_CCI_URL;
    config.elUrl = process.env.VUE_APP_EL_URL;
    config.accountConveyCode = process.env.VUE_APP_ACCOUNT_CONVEY_CODE;
    config.accountNetDOtCode = process.env.VUE_APP_ACCOUNT_NET_DOT_CODE;
    config.srmItsmAppId = process.env.VUE_APP_SRM_ITSM_APP_ID;
    config.tmsItsmAppId = process.env.VUE_APP_TMS_ITSM_APP_ID;
    config.bmsItsmAppId = process.env.VUE_APP_BMS_ITSM_APP_ID;
    config.cciItsmAppId = process.env.VUE_APP_CCI_ITSM_APP_ID;
    config.systemId = process.env.VUE_APP_SYSTEM_ID;
    config.productId = process.env.VUE_APP_PRODUCT_ID;
    config.oneClassifyCode = process.env.VUE_APP_ONE_CLASSIFY_CODE;
    config.twoClassifyCode = process.env.VUE_APP_TOW_CLASSIFY_CODE;
    config.threeClassifyCode = process.env.VUE_APP_THREE_CLASSIFY_CODE;
    config.monitorAppKey = process.env.VUE_APP_MONITOR_APP_KEY;
    config.monitorServiceName = process.env.VUE_APP_MONITOR_SERVICE_NAME;
    config.monitorDsn = process.env.VUE_APP_MONITOR_DSN;
} else {
    config.env = 'UAT';
    config.singlePointLogin = 'https://signinuat.midea.com/?service=';
    config.singlePointLogout = 'https://signinuat.midea.com/logout?service=';
    config.staffSelector = {
        url: 'http://devcloud.midea.com/builder/m_staff_selector-V1.0.1/index.js',
        project: '/mframework'
    };
    config.appId = 'MFRAMEWORK_CLI3.0';
    config.defaultPage = '/index.html';
    config.uploadAppId = '32883248FE8946CCA59DDB36C80BF571';
    config.uploadAppKey = 'Vgjmcgy24Hjwb6Buq7ZfRz0uX2NebGJFrfYDRRPZ';
    config.apiUrl = '/';
    config.filePreviewUrl = 'http://imipsit.midea.com/';
    config.pdfPreviewUrl = 'http://anapi-sit.annto.com';
    config.bucket = 'srm';
    config.bigDataLogTokenUrl = 'https://apisit.midea.com/bigds/token/bigdatatoken';
    config.bigDataLogUrl = 'https://apisit.midea.com/bigds/maidian';
    config.bigDataLogAppSecrect = 'kio98-a1klk1j-nh39o1-g12ju-k1ai10123';
    config.bigDataLogAppName = 'C-LSRM';
    config.stampUrl = ' https://fenqitest.midea.com/msigndev';
    config.mideaPay = 'https://in.mideaepayuat.com/gateway.htm';
    config.printPDFUrl = 'https://luatapi.annto.com/';
    config.cloudPrintUrl = 'https://apiuat.midea.com/T-LPAAS/logistics-paas-printer/pdf/';
    config.microCopUrl = '//localhost.annto.com:8100/index.html';
    config.microCciUrl = 'https://cci-uat.annto.com/index.html';
    config.microReportUrl = 'https://lreport-uat.annto.com/index.html#/index';
    config.microAmsUrl = 'https://localhost.annto.com:8090/';
    config.elUrl = 'https://el-uat.annto.com';
    config.accountConveyCode = '231545a7-5d75-4bc3-8204-3b3cb205ca8d';
    config.accountNetDOtCode = '6182281d-ca92-4969-9291-bc962a976d04';
    // config.tmsItsmAppId = '0685039c5c3f46fbad071e69a9a0a3fa'; // uat appId，因运营平台uat未维护，使用时只能看事件分类，不能提交
    // config.bmsItsmAppId = '799166adc389400aa36b93fe78a481f7'; // uat appId，因运营平台uat未维护，使用时只能看事件分类，不能提交
    config.srmItsmAppId = '6a9a5923298743b980349fe41dfdca10';
    config.tmsItsmAppId = '8c289b8975874fa2a79c1f1c63ba0333';
    config.bmsItsmAppId = '8c289b8975874fa2a79c1f1c63ba0333';
    config.cciItsmAppId = '79c4143c2bc34475baec884fd40a4105';
    config.systemId = '372827d0-8f08-4ec8-a218-c0dd37f47185';
    config.productId = 'f9a2e030-2575-4e4d-a483-d276f906f53f';
    config.oneClassifyCode = 'yyyw';
    config.twoClassifyCode = 'yyyw_tms01';
    config.threeClassifyCode = 'yyyw_tms01_87a55c48148945159c0562fea0fc3a1e';
    config.monitorAppKey = '6729cfde0da6477db34a51ba1527d55b';
    config.monitorServiceName = 'c-lsrm-web-supplier';
    config.monitorDsn = 'https://mwmr.midea.com/xops/web-endpoint/report';
}

export default config;
